import React from 'react';
import PropTypes from 'prop-types';

import {injectIntl} from "react-intl";
import {Field} from 'redux-form';
import FieldSelect from '../../fields/fieldSelect/FieldSelect';

@injectIntl
export default class ConstructedSelectField extends React.PureComponent {
  render() {
    const {intl, field} = this.props;

    return (
      <Field
        name={field.code}
        label={`${field.name} ${field.required ? '*' : ''}`}
        required={field.required}
        component={FieldSelect}
      >
        {field.required ? (
          <option value="" disabled selected hidden>
            {intl.formatMessage({id: 'page.checkout.field.select.option'})}
          </option>
        ) : (
          <option value=""/>
        )}

        {field.choices.map(choice => (
          <option key={choice.code} value={choice.code}>{choice.label}</option>
        ))}
      </Field>
    );
  }
}



// WEBPACK FOOTER //
// ./components/constructedForm/fields/ConstructedSelectField.js